<template>
  <div class="">
    <hello v-show="!showWorld"></hello>
    <div v-show="showWorld" class="">
      <zap-slideout ref="slideout"></zap-slideout>
      <div class="fullscreen">
        <div id="world"></div>
        <div class="overlay hide-cursor"></div>
        <div class="hint-container">
          <div class="hint-background">
            <div id="hint"></div>
            <div class="hint-text">
              zoom in to enter chapter
            </div>
          </div>
        </div>
        <div class="debug">
          <!-- <button @click="reloadChapter">reload chapter</button> -->
        </div>
        <html-cursor></html-cursor>
      </div>
    </div>
  </div>
</template>

<script>
import App from '../world/App'
import Hello from './Hello'
import Slideout from './Slideout'
import HTMLCursor from './HTMLCursor.vue'
import chapters from '../assets/chapters.json'
let app
export default {
  name: 'world',
  components: {
    'zap-slideout': Slideout,
    'html-cursor': HTMLCursor,
    'hello': Hello
  },
  data () {
    return {
      showWorld: false
    }
  },
  methods: {
    onEnterSite () {
      this.showWorld = true
    },
    onShowIntro () {
      this.showWorld = false
    },
    onMouseOverSlideout (over) {
      this.$bus.$emit('hide-cursors', over)
    },
    convertChaptersToRoutes (chapters) {
      // return chapters.map()
      return []
    },
    loadApp () {
      chapters.forEach(language => {
        if (language.language === this.language) {
          app = new App('world', this.$bus, this.$router, language.chapters)
        }
      })
      this.world = app
      window.world = app
      // app.gotoPosition(this.$route.meta.zoneIndex)
      app.gotoPosition(0)
    },
    reloadChapter () {
      this.world.shownChapter.reload()
        .then(() => {
          this.world.gotoPosition(this.world.currentPositionIndex)
        })
    }
  },
  mounted () {
    this.loadApp()
    this.$bus.$on('enter-site', this.onEnterSite)
    this.$bus.$on('show-intro', this.onShowIntro)
    this.$refs.slideout.$el.addEventListener('mouseenter', this.onMouseOverSlideout.bind(this, true))
    this.$refs.slideout.$el.addEventListener('mouseleave', this.onMouseOverSlideout.bind(this, false))
  },
  watch: {
    '$route' (to, from) {
      app.gotoPosition(to.meta.zoneIndex)
    }
  }
}
</script>

<style>
 .hint-container {
   text-align: center;
   /*display: none;*/
   position: absolute;
   bottom: 0;
   left: 0;
   right: 0;
   display: none;
 }
 .hint-background {
      background-color: white;
      margin: 0 auto;
      /*display: inline-block;*/
      padding: 16px;
      /*border-radius: 8px;*/
      position: relative;
      top: 100%;

  }
  .hint-container.show{
    display: block;
  }
  #hint {
    display: inline-block;
  }

  .block-container {
      position: absolute;
      bottom: 0;
      left: 0;
      /* max-height: calc(100% - 76px); */
  }

  .block {
      margin: 16px;
      font-size: 14px;
      width: 320px;
      background: white;
      box-sizing: border-box;
      max-width: calc(100vw - 32px);
      float: left;
      max-height: calc(100vh - 76px);
      overflow-y: auto;
      position: relative;
      transition: right 1s;
      right: 390px;
  }

  .block.shown{
    right: 0px;
  }

  .block img {
      width: 100%;
      display: block;
      margin: 24px 0;
  }

  .explainer {
      /* padding: 24px 4px 24px 24px; */
      width: 270px;
      float: left;
      /* max-height: 100px; */
      font-size: 14px;
      /* overflow-y: scroll; */
      border: 4px solid black;
      margin-top: 56px;
      position: absolute;
      bottom: 0;
      margin: 16px;
      left: 336px;
  }
  .explainer a {
    color: black;
    font-weight: 700;
  }
  .explainer .close {
    color: #0071FF;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 14px;
    line-height: 1.6;
    font-weight: bold;
    cursor: pointer;
    padding: 4px 8px;
  }
  .anchor {
    font-weight: bold;
    text-decoration: none;
    cursor: pointer;
    background: #0071FF;
    color: white;
    padding: 2px 8px;
  }

  .explainer .scroll {
    max-height: 160px;
    overflow-y: auto;
    padding: 24px;
    border: 4px solid black;
  }

  .block, .explainer {
    line-height: 1.6;
    text-align: left;
  }
  .explainer h4 {
    color: white;
    background: #0071FF;
    display: inline-block;
    margin: 0;
    padding: 4px 8px;
  }

  .block h3 {
    color: white;
    background: black;
    padding: 16px 24px;
    font-size: 24px;
    text-align: left;
    margin: 0;
  }

  .block p {
    padding: 24px 24px 8px;
    margin: 0;
  }

  .debug {
    /* display: none; */
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999;
  }


  @media(max-width: 800px) {
    /* .block {display:none;} */
    h1.popup.intro {
      font-size:24px;
      padding: 37px;
    }
    .block {
      margin: 8px;
    }
    .block h3 {
      font-size: 18px;
      padding: 8px 44px 44px 16px;
      position: relative;
    }
    .block h3::after {
      content: '';
      position: absolute;
      top: 16px;
      right: 14px;
      width: 14px;
      height: 14px;
      display: block;
      border-right: 4px solid white;
      border-top: 4px solid white;
      transform: rotate(-45deg);
      transition: all .4s ease-in-out;
    }
    .block.open h3::after {
      transform: rotate(135deg);
      top: 8px;
    }
    .block p {
      padding: 8px 16px;
    }
    .block .block-content {
      box-sizing: border-box;
      transition: all .7s ease-in-out;
      max-height: 0em;
      overflow: hidden;
    }
    .block.open .block-content {
      max-height: 100em;
    }
  }
  
  
</style>



// WEBPACK FOOTER //
// src/components/World.vue